/* ============================================================
   Dwell & Company — Product page (PDP) behavior
   - "?" info popovers (hover on desktop, tap on mobile) with a
     clickable phone number in the Delivery popover
   - Delivery box: gold check + "Delivery Available" + truck + "?"
   - Pre-Order box: normalize label + add "?"
   - Custom art (product type Artwork): replace the "In Stock" badge with an ETA badge
   - Mobile: move product name + dimensions above the image
   - Keep the (square-fit) gallery height in sync after images load
   Idempotent; re-applies after variant changes / section re-renders.
   ============================================================ */
(function () {
  'use strict';
  var MOBILE = '(max-width:749px)';

  /* Gold check + truck icons. TODO: swap TRUCK for Dwell's own truck asset when provided. */
  var GOLD_CHECK = '<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M16.14 6.98a1.5 1.5 0 0 0-2.28-1.95L7.92 11.8 6.06 9.94A1.5 1.5 0 1 0 3.94 12.06l3 3c.29.29.68.44 1.1.44a1.5 1.5 0 0 0 1.1-.52l7-8Z"/></svg>';
  var TRUCK = '<svg viewBox="0 0 48 32" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h24v18H3z"/><path d="M27 12h8l6 6v6H27z"/><circle cx="13" cy="25" r="3.2" fill="var(--dc-pop-bg)"/><circle cx="35" cy="25" r="3.2" fill="var(--dc-pop-bg)"/></svg>';
  var STORE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M3.5 9 5 4.6a1 1 0 0 1 .95-.6h12.1a1 1 0 0 1 .95.6L20.5 9"/><path d="M3.5 9a2.4 2.4 0 0 0 4.25 1.1 2.4 2.4 0 0 0 4.25 0 2.4 2.4 0 0 0 4.25 0A2.4 2.4 0 0 0 20.5 9"/><path d="M5 11.4V20h14v-8.6"/><path d="M10 20v-4.6h4V20"/></svg>';
  var CLOCK = '<svg class="icon" aria-hidden="true" focusable="false" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>';

  /* build a "?" trigger + popover (popHtml may contain links) */
  function makeInfo(popHtml, label) {
    var wrap = document.createElement('span'); wrap.className = 'dc-info-wrap';
    var btn = document.createElement('button'); btn.className = 'dc-info'; btn.type = 'button'; btn.textContent = '?';
    btn.setAttribute('aria-label', label || 'More information');
    var pop = document.createElement('span'); pop.className = 'dc-pop'; pop.innerHTML = popHtml;
    wrap.appendChild(btn); wrap.appendChild(pop);
    return wrap;
  }
  function bindInfo(wrap) {
    var btn = wrap.querySelector('.dc-info');
    if (btn.__dcBound) return; btn.__dcBound = true;
    btn.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      var open = wrap.classList.contains('is-open');
      closeAll();
      if (!open) wrap.classList.add('is-open');
    });
  }
  function closeAll() {
    document.querySelectorAll('.dc-info-wrap.is-open').forEach(function (w) { w.classList.remove('is-open'); });
  }

  /* -------- Delivery box -------- */
  /* Target ONLY our custom delivery box (inside a custom_liquid block), never
     Shopify's native pickup-availability preview (which renders async on in-stock
     products and would otherwise get transformed into a 2nd "Delivery Available"). */
  function findDeliveryBox() {
    var inCustom = document.querySelector('.custom-liquid .pickup-availability-preview');
    if (inCustom) return inCustom;
    var all = document.querySelectorAll('.pickup-availability-preview');
    for (var i = 0; i < all.length; i++) {
      var b = all[i];
      if (b.closest('pickup-availability, .product__pickup-availabilities')) continue;
      if (/602-0360|Delivery available at checkout/i.test(b.textContent)) return b;
    }
    return null;
  }
  function initDelivery() {
    var box = findDeliveryBox();
    if (!box || box.classList.contains('dc-delivery')) return;
    box.classList.add('dc-delivery');
    box.innerHTML =
      '<span class="dc-check">' + GOLD_CHECK + '</span>' +
      '<span class="dc-delivery-label">Delivery Available</span>' +
      '<span class="dc-truck">' + TRUCK + '</span>';
    box.appendChild(makeInfo(
      'Shipping Calculated at Checkout, or give us a call at <a href="tel:+18136020360">(813)&nbsp;602-0360</a>.',
      'Delivery information'));
  }

  /* -------- Pickup box (Shopify native pickup-availability, restyled) -------- */
  function initPickup() {
    var box = null;
    var all = document.querySelectorAll('pickup-availability .pickup-availability-preview, .product__pickup-availabilities .pickup-availability-preview');
    for (var i = 0; i < all.length; i++) { if (!all[i].classList.contains('dc-pickup')) { box = all[i]; break; } }
    if (!box) return;
    var m = (box.textContent || '').match(/usually ready in\s+([0-9][\w\s\-+]*?)(?=\s*view|\s*$)/i);
    var ready = m ? m[1].trim() : '24 hours';
    box.classList.add('dc-pickup');
    box.innerHTML =
      '<span class="dc-check">' + GOLD_CHECK + '</span>' +
      '<span class="dc-delivery-label">Pickup Available. Usually ready in ' + ready + '.</span>' +
      '<span class="dc-store">' + STORE + '</span>';
    box.appendChild(makeInfo(
      'Pickup Address: 4912 S Lois Ave, Tampa, Fl, 33611. Store Number: <a href="tel:+18136020360">813-602-0360</a>',
      'Pickup information'));
  }

  /* -------- Custom art: ETA badge instead of "In Stock" -------- */
  function isArt() {
    var p = window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product;
    return !!(p && /^artwork$/i.test(p.type || ''));
  }
  function initArtEta() {
    if (!isArt()) return;
    var inv = document.querySelector('.product__inventory');
    if (!inv || inv.classList.contains('dc-art-eta')) return;
    var inner = inv.querySelector('.product__inventory-inner');
    if (!inner) return;
    inv.classList.add('dc-art-eta');
    inv.classList.remove('dc-preorder');
    inner.className = 'product__inventory-inner';
    inner.style.color = '#e8c170';
    inner.innerHTML = CLOCK + 'ETA 2-3 Weeks for Your Custom Order';
  }

  /* -------- Pre-Order box -------- */
  function initPreorder() {
    var inv = document.querySelector('.product__inventory');
    if (!inv || inv.classList.contains('dc-art-eta')) return;
    var inner = inv.querySelector('.product__inventory-inner') || inv;
    if (!/pre-?order/i.test(inner.textContent)) { inv.classList.remove('dc-preorder'); return; }
    inv.classList.add('dc-preorder');
    if (inner.__dcDone) return;
    for (var i = 0; i < inner.childNodes.length; i++) {
      var n = inner.childNodes[i];
      if (n.nodeType === 3 && /pre-?order/i.test(n.nodeValue)) { n.nodeValue = ' Pre-Order – '; break; }
    }
    if (!inner.querySelector('.dc-info-wrap')) {
      inner.appendChild(makeInfo(
        'Availability dates are our best estimations and are subject to change.',
        'Pre-order availability information'));
    }
    inner.__dcDone = true;
  }

  function bindAll() { document.querySelectorAll('.dc-info-wrap').forEach(bindInfo); }

  /* -------- Mobile: name + dimensions above the image -------- */
  var heading = null;
  function mobileHeading() {
    var media = document.querySelector('.product__media-wrapper');
    if (!media) return;
    var title = document.querySelector('.product__title__wrapper');
    var dimsEl = document.getElementById('dc-dims');
    var dims = dimsEl ? dimsEl.closest('.custom-liquid') : null;
    var nodes = [title, dims].filter(Boolean);
    if (!nodes.length) return;
    nodes.forEach(function (n) {
      if (!n.__dcPh) { n.__dcPh = document.createComment('dc-anchor'); if (n.parentNode) n.parentNode.insertBefore(n.__dcPh, n); }
    });
    if (window.matchMedia(MOBILE).matches) {
      if (!heading) { heading = document.createElement('div'); heading.className = 'dc-mobile-heading'; }
      if (heading.nextSibling !== media || heading.parentNode !== media.parentNode) {
        media.parentNode.insertBefore(heading, media);
      }
      nodes.forEach(function (n) { if (n.parentNode !== heading) heading.appendChild(n); });
    } else {
      nodes.forEach(function (n) { if (n.__dcPh && n.__dcPh.parentNode) n.__dcPh.parentNode.insertBefore(n, n.__dcPh); });
      if (heading && heading.parentNode) heading.parentNode.removeChild(heading);
      heading = null;
    }
  }

  /* -------- Keep the square-fit gallery height correct once images load -------- */
  function syncGallery() {
    document.querySelectorAll('.product__media-list.swiper').forEach(function (el) {
      var sw = el.swiper;
      if (sw) { try { sw.update(); if (sw.updateAutoHeight) sw.updateAutoHeight(0); } catch (e) {} }
    });
  }

  function applyDynamic() { initDelivery(); initPickup(); initArtEta(); initPreorder(); bindAll(); }
  function applyAll() { mobileHeading(); applyDynamic(); }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    applyAll();
    syncGallery();

    document.addEventListener('click', function (e) { if (!e.target.closest('.dc-info-wrap')) closeAll(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });

    var rt;
    window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () { mobileHeading(); syncGallery(); }, 150); });

    window.addEventListener('load', function () { syncGallery(); setTimeout(syncGallery, 300); });
    document.querySelectorAll('.product__media-list img').forEach(function (im) {
      if (!im.complete) im.addEventListener('load', function () { setTimeout(syncGallery, 30); }, { once: true });
    });

    var info = document.querySelector('.product__info-container') || document.querySelector('.product__info-wrapper');
    if (info && window.MutationObserver) {
      var mt;
      var mo = new MutationObserver(function () { clearTimeout(mt); mt = setTimeout(applyDynamic, 120); });
      mo.observe(info, { childList: true, subtree: true });
    }
    document.addEventListener('shopify:section:load', function () { setTimeout(function () { applyAll(); syncGallery(); }, 120); });
  });
})();
